import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '../../service/settings.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-work-task-template-workflow-dialog',
    templateUrl: './work-task-template-workflow-dialog.component.html',
    standalone: false
})
export class WorkTaskTemplateWorkflowDialogComponent implements OnInit {
  workflowForm!: FormGroup;
  workflows: any[] = [];
  existingWorkflowAction: any;
  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<WorkTaskTemplateWorkflowDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private settingsService: SettingsService
  ) {
    dialogRef.disableClose = true;
    this.existingWorkflowAction = data?.workflowAction || null;
  }

  ngOnInit(): void {
    const contextId = this.settingsService.contextId$;

    this.settingsService.getWorkflowTemplates(contextId).pipe(takeUntil(this.destroy$)).subscribe(workflowTemplates => {
      this.workflows = workflowTemplates || [];
    });

    this.workflowForm = this.fb.group({
      workflowTemplateId: ['', Validators.required],
      synchronous: [false]
    });

    // If editing existing workflow action, populate form
    if (this.existingWorkflowAction && this.existingWorkflowAction.action === 'startWorkflow') {
      this.workflowForm.patchValue({
        workflowTemplateId: this.existingWorkflowAction.parameters?.workflowTemplateId || '',
        synchronous: this.existingWorkflowAction.parameters?.synchronous || false
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close([null, false]);
  }

  onSave(): void {
    if (this.workflowForm.valid) {
      const formValue = this.workflowForm.value;
      const workflowAction = {
        action: 'startWorkflow',
        parameters: {
          workflowTemplateId: formValue.workflowTemplateId,
          synchronous: formValue.synchronous || false
        }
      };
      this.dialogRef.close([workflowAction, true]);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
